import {useEffect, useState} from "react"
import {updateToken, useGetAuthToken} from "../store/api/authSlice"
import {useAuth0} from "@auth0/auth0-react"
import {useDispatch} from "../store/store"
import {getServiceHubToken} from "../features/all-apps/serviceHubApi"

export const useGetAndFetchToken = () => {
    const token = useGetAuthToken()
    const {getAccessTokenSilently, user} = useAuth0()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // Токен авторизации
        getAccessTokenSilently({
            detailedResponse: true,
            authorizationParams: {audience: process.env.REACT_APP_AUTH_AUDIENCE}
        }).then(r => {
            setLoading(true)
            dispatch(updateToken(r.access_token))
            setLoading(false)
            // Warm up the Service Hub session so the "All apps" dropdown opens without a popup.
            getServiceHubToken().catch(() => {})
        })
    }, [dispatch, getAccessTokenSilently])

    return {loading, token, user}
}
